import { render, staticRenderFns } from "./UpdateQuestionCategoryModal.vue?vue&type=template&id=759195b8&scoped=true&"
import script from "./UpdateQuestionCategoryModal.vue?vue&type=script&lang=js&"
export * from "./UpdateQuestionCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759195b8",
  null
  
)

export default component.exports